<main *ngIf="this.records">
  <div class="table-title card-header">
    <div class=" table-header d-flex">
      <h4 class="table-title">
        {{TABLE_TITLE + ((this.newDate.getMonth() + 1) | monthToString ) + " " + this.newDate.getFullYear()}}
      </h4>
      <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openInfoDialog()">
        <i class="fa fa-info-circle fa-sm"></i>
      </button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table footable" data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }'
           matSort (matSortChange)="triggerSorting($event)">
      <thead class="thead-dark">
      <tr>
        <th mat-sort-header="{{header[0]}}" *ngFor="let header of TABLE_SORT_HEADERS">
          {{header[1]}}
        </th>
        <th></th>
      </tr>
      </thead>

      <tbody>
      <tr *ngIf="loader.isActive()">
        <td colspan="12">
          <div class="loader-container">
            <app-loader></app-loader>
          </div>
        </td>
      </tr>

      <tr *ngIf="dataStatus.isFailed()">
        <td colspan="12">
          <div class="alert" role="alert" [ngClass]="dataStatus.errorCSS()">
            {{dataStatus.errorMessage}}
          </div>
        </td>
      </tr>

      <tr *ngIf="dataStatus.thereIsInfo()">
        <td colspan="12">
          <div class="alert" role="alert" [ngClass]="dataStatus.infoCSS()">
            {{dataStatus.infoMessage}}
          </div>
        </td>
      </tr>

      <ng-container *ngIf="dataStatus.isSuccesfully()">
        <tr *ngFor="let record of records">
          <td>
            <a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">
              {{record.isin ? record.isin : '--'}}
            </a>
          </td>
          <td>{{record.emittente ? record.emittente : '--'}}</td>
          <td>{{record.descrizione ? record.descrizione : '--'}}</td>
          <td>{{record.scadenza ? (record.scadenza | date:'dd/MM/yyyy') : '--'}}</td>
          <td *ngIf="record.sottostanteBasket">
            <a [routerLink]="[ '/menu/sottostante']" [queryParams]="{ sottostante: record.sottostanteBasket}">
              {{record.sottostanteBasket ? record.sottostanteBasket : '--'}}
            </a>
          </td>
          <td>{{record.settore ? record.settore : '--'}}</td>

          <td>
            <a (click)="addIsinToWatchlist(record.isin)" matTooltip="Aggiungi isin ad una watchlist">
              <img [src]="'assets/images/icons/addToWatchlistGlassesSmall.png'" alt="Aggiungi alla watchlist" class="watchlistIcon">
            </a>
          </td>
        </tr>
      </ng-container>
      </tbody>

      <tfoot *ngIf="!loader.isActive()" class="footer-view-all">
      <tr>
        <td colspan="100%">
          <a class="nav-link" [routerLink]="[VIEW_ALL_PATH]">
            <i class="fa fa-plus"></i> Visualizza tutti
          </a>
        </td>
      </tr>
      </tfoot>
    </table>

  </div>
</main>
